import {
  AccountingPaymentStatus,
  AccountingSubType,
} from "@entities/accounting/lib/constants";
import { IBrandAccounting } from "@shared/lib/types/accounting";

export function getDocTypeLabel(subType: AccountingSubType): string {
  switch (subType) {
    case AccountingSubType.invoice:
      return "Invoice";
    case AccountingSubType.creditNote:
      return "Credit Note";
    case AccountingSubType.debitNote:
      return "Debit Note";
    default:
      return String(subType);
  }
}

export function getPaymentStatusLabel(status: AccountingPaymentStatus): string {
  switch (status) {
    case AccountingPaymentStatus.paid:
      return "Payment Received";
    case AccountingPaymentStatus.pending:
      return "Payment Pending";
    case AccountingPaymentStatus.partiallyPaid:
      return "Partial Payment Received";
    case AccountingPaymentStatus.cnIssued:
      return "Credit Note Issued";
    default:
      return String(status);
  }
}

export function isOverdue(doc: IBrandAccounting): boolean {
  return doc.isOverdue ?? false;
}

export function getOverdueDays(doc: IBrandAccounting): number {
  return doc.isOverdue ? +(doc.overdueByDays || 0).toFixed(1) : 0;
}

export type StatusStyleKey =
  | "paid"
  | "partiallyPaid"
  | "cnIssued"
  | "pendingOverdue"
  | "pending"
  | "default";

export function getStatusStyleKey(
  status: AccountingPaymentStatus,
  overdue: boolean
): StatusStyleKey {
  if (status === AccountingPaymentStatus.paid) return "paid";
  if (status === AccountingPaymentStatus.partiallyPaid) return "partiallyPaid";
  if (status === AccountingPaymentStatus.cnIssued) return "cnIssued";
  if (status === AccountingPaymentStatus.pending && overdue)
    return "pendingOverdue";
  if (status === AccountingPaymentStatus.pending) return "pending";
  return "default";
}

export type DocTypeIconStyleKey = "creditNote" | "debitNote" | "invoice";

export function getDocTypeIconStyleKey(
  subType: AccountingSubType
): DocTypeIconStyleKey {
  switch (subType) {
    case AccountingSubType.creditNote:
      return "creditNote";
    case AccountingSubType.debitNote:
      return "debitNote";
    default:
      return "invoice";
  }
}
